module.exports = __webpack_public_path__ + "static/media/es.1b8c31d5.svg";